<template>
  <div style="background-color: rgb(244, 245, 246);height: 100%">
    <div id="one">
      <div
        style="width: 100%; display: flex; flex-direction: column;
						align-items: center;justify-items: center;margin-top: 10px;margin-bottom: 10px"
      >
        <div
          style="font-size: 16px;background-color: white;width: 100%;padding-left: 40%;padding-top: 2%;padding-bottom: 2%;"
        >我的考试</div>

        <div style="background-color: white;margin-top: 2%;width: 100%">
          <Form ref="formItem" :model="formItem" :rules="ruleValidate" :label-width="80">
            <FormItem label="姓名" prop="name">
              <Input v-model="formItem.name" placeholder="请输入您的姓名"></Input>
            </FormItem>
            <Divider />
            <FormItem label="电话" prop="cellphone">
              <Input v-model="formItem.cellphone" placeholder="请输入您的电话号码"></Input>
            </FormItem>
            <Divider />
            <FormItem label="身份证" prop="idCard">
              <Input v-model="formItem.idCard" placeholder="请输入您的身份证号码"></Input>
            </FormItem>
            <Divider />
            <FormItem label="企业" prop="company">
              <Input v-model="formItem.company" placeholder="请输入您的企业名称"></Input>
            </FormItem>
          </Form>
        </div>
        <Button
          type="primary"
          style="margin-top: 8%;width: 300px"
          @click="submitForm('formItem')"
        >开始考试</Button>
      </div>
    </div>
    <div id="two">
      <div
        style="width: 100%; display: flex; flex-direction: column;
						align-items: center;justify-items: center;margin-top: 10px;margin-bottom: 10px"
      >
        <div
          style="font-size: 16px;background-color: white;width: 100%;padding-left: 40%;padding-top: 2%;padding-bottom: 2%;"
        >我的考试</div>

        <div style="background-color: white;margin-top: 2%;width: 100%">
          <Form :model="examInfo" :label-width="80">
            <FormItem label="考试名称" prop="name">
              <span style="text-align: right; margin-left: 68%;">{{examInfo.name}}</span>
            </FormItem>
            <Divider />
            <FormItem label="已用时" prop="time">
              <span style="text-align: right;    margin-left: 68%;">{{time}}</span>
            </FormItem>
            <Divider />
          </Form>
          <div style="background-color: white;margin-top: 10%;width: 100%">
            <div style="margin-left: 4%;margin-top: 4%" v-for=" (item,index) in questionBankVos ">
              <div style="margin-bottom: 5%">{{index +1 }}. {{item.content}}</div>
              <Divider />
              <CheckboxGroup v-model="item.selectAnswerArr">
                <Checkbox label="A" style="margin-bottom: 2%;margin-top: 2%">A. {{item.optionA}}</Checkbox>
                <Divider />
                <Checkbox label="B" style="margin-bottom: 2%;margin-top: 2%">B. {{item.optionB}}</Checkbox>
                <Divider />
                <Checkbox label="C" style="margin-bottom: 2%;margin-top: 2%">C. {{item.optionC}}</Checkbox>
                <Divider />
                <Checkbox label="D" style="margin-bottom: 2%;margin-top: 2%">D. {{item.optionD}}</Checkbox>
              </CheckboxGroup>
            </div>
            <Divider />
          </div>
          <Button
            type="primary"
            style="margin-top: 8%;width: 300px;margin-left: 8%"
            @click="finishExam()"
          >提交</Button>
        </div>
      </div>
    </div>
    <div id="three">
      <div
        style="width: 100%; display: flex; flex-direction: column;
						align-items: center;justify-items: center;margin-top: 10px;margin-bottom: 10px"
      >
        <div
          style="font-size: 16px;background-color: white;width: 100%;padding-left: 40%;padding-top: 2%;padding-bottom: 2%;"
        >我的考试</div>

        <div style="background-color: white;width: 100%;margin-top: 4%">
          <Form :model="formItem" :label-width="80">
            <FormItem label="考试名称" prop="name">
              <span style="text-align: right; margin-left: 68%;">{{formItem.name}}</span>
            </FormItem>
            <Divider />
            <FormItem label="电话" prop="time">
              <span style="text-align: right;    margin-left: 68%;">{{formItem.cellphone}}</span>
            </FormItem>
            <Divider />
            <FormItem label="身份证" prop="name">
              <span style="text-align: right; margin-left: 68%;">{{formItem.idCard}}</span>
            </FormItem>
            <Divider />
            <FormItem label="企业" prop="time">
              <span style="text-align: right;    margin-left: 68%;">{{formItem.company}}</span>
            </FormItem>
            <Divider />
            <FormItem label="分数" prop="name">
              <span style="text-align: right; margin-left: 68%;">{{formItem.score}}</span>
            </FormItem>
            <Divider />
            <FormItem label="通过状态" prop="time">
              <span
                style="text-align: right;    margin-left: 68%;"
                v-if="formItem.passStatus == 1"
              >是</span>
              <span
                style="text-align: right;    margin-left: 68%;"
                v-if="formItem.passStatus == 0"
              >否</span>
            </FormItem>
            <Divider />
            <FormItem label="开始时间" prop="name">
              <span style="text-align: right; margin-left: 50%;">{{formItem.startTime}}</span>
            </FormItem>
            <Divider />
            <FormItem label="结束时间" prop="time">
              <span style="text-align: right;    margin-left: 50%;">{{formItem.endTime}}</span>
            </FormItem>
            <Divider />
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  data() {
    return {
      examInfo: {},
      time: "00:00:00",
      formItem: {
        name: "",
        cellphone: "",
        idCard: "",
        company: ""
      },
      answer: [],
      ruleValidate: {
        name: [{ required: true, message: " ", trigger: "blur" }],
        cellphone: [{ required: true, message: " ", trigger: "blur" }],
        idCard: [{ required: true, message: " ", trigger: "blur" }],
        company: [{ required: true, message: " ", trigger: "blur" }]
      },
      hour: 0,
      minute: 0,
      second: 0,
      questionBankVos: []
    };
  },
  mounted: function() {
    // document.getElementById("one").style.display="none";//隐藏
    //
    // document.getElementById("two").style.display="";//显
    document.getElementById("two").style.display = "none"; //隐藏
    document.getElementById("three").style.display = "none"; //隐藏

    document.getElementById("one").style.display = ""; //显
  },
  methods: {
    finishExam() {
      // console.log(this.questionBankVos);
      // 获取分数
      let score = 0;
      let scanCodeAnswerEmployeeDtos = [];
      for (var i = 0; i < this.questionBankVos.length; i++) {
        let item = {
          questionId: this.questionBankVos[i].id,
          answer: JSON.stringify(this.questionBankVos[i].selectAnswerArr),
          scanCodeEmployeeId: this.formItem.id
        };
        scanCodeAnswerEmployeeDtos.push(item);
        if (this.questionBankVos[i].correctAnswer) {
          let correctAnswer = this.questionBankVos[i].correctAnswer.split(",");
          if (correctAnswer) {
            if (
              correctAnswer.sort().toString() ==
              this.questionBankVos[i].selectAnswerArr.sort().toString()
            ) {
              score = score + 10;
            }
          }
        } else {
          score = score + 10;
        }
      }
      // console.log(score);
      this.formItem.score = score;
      this.formItem.questionnaireId = this.examInfo.id;
      if (this.examInfo.passingScore) {
        if (score < this.examInfo.passingScore) {
          this.formItem.passStatus = 0;
        } else {
          this.formItem.passStatus = 1;
        }
      } else {
        this.formItem.passStatus = 1;
      }
      this.formItem.scanCodeAnswerEmployeeDtos = scanCodeAnswerEmployeeDtos;
      // 保存记录
      this.componentsMoudel.httpRequest
        .getRequestHander("/scancodeexamrecord/update")
        .openLoad()
        .startPost(this.formItem)
        .then(res => {
          this.formItem = res.body.data;
          this.$Message.success("提交成功");
          document.getElementById("two").style.display = "none"; //隐藏
          document.getElementById("one").style.display = "none"; //隐藏

          document.getElementById("three").style.display = ""; //显
        });
    },
    startTime() {
      setInterval(this.timer, 1000);
    },
    timer() {
      var h, m, s;
      var millisecond = 0; //毫秒
      this.second++;
      if (this.second >= 60) {
        this.second = 0;
        this.minute = this.minute + 1;
      }

      if (this.minute >= 60) {
        this.minute = 0;
        this.hour = this.hour + 1;
      }
      if (this.hour < 10) {
        h = "0" + this.hour;
      } else {
        h = this.hour;
      }
      if (this.minute < 10) {
        m = "0" + this.minute;
      } else {
        m = this.minute;
      }
      if (this.second < 10) {
        s = "0" + this.second;
      } else {
        s = this.second;
      }
      this.time = h + ":" + m + ":" + s;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.formItem.questionnaireId = this.examInfo.id;
          this.componentsMoudel.httpRequest
            .getRequestHander("/scancodeexamrecord/save")
            .openLoad()
            .startPost(this.formItem)
            .then(res => {
              if (res.body.status_code == 100) {
                this.formItem = res.body.data;
                document.getElementById("one").style.display = "none"; //隐藏
                document.getElementById("three").style.display = "none"; //隐藏
                document.getElementById("two").style.display = ""; //显
                this.startTime();
              } else {
                this.$message.error("进入考试失败，请检查网络");
              }
            });
        } else {
          this.$Message.error("请输入必要的信息!");
        }
      });
    },
    getUrlParam() {
      var query = window.location.href;
      var vars = query.split("?id=")[1];
      return vars;
    }
  },
  created() {
    let id = this.getUrlParam();
    this.componentsMoudel.httpRequest
      .getRequestHander("/scancodeexamrecord/getQuestionsInfo/" + id)
      .openLoad()
      .startGet()
      .then(res => {
        this.examInfo = res.body.data;
        this.questionBankVos = this.examInfo.questionBankVos;
        // console.log(this.examInfo);
      });

    // let obj = this.$route.params.key;
    // if (this.$route.params.key) {

    // } else {
    //
    // }
  }
};
</script>

<style scoped>
.addBtn {
  display: block;
  width: 300px;
  margin: 0 auto;
}

.ivu-form-item {
  margin-bottom: 2px !important;
  vertical-align: top;
  zoom: 1;
}
.ivu-divider-horizontal {
  display: block;
  height: 1px;
  width: 100%;
  min-width: 100%;
  margin: 0 !important;
  clear: both;
}
.ivu-input {
  display: inline-block;
  width: 100%;
  height: 32px;
  line-height: 1.5;
  padding: 4px 7px;
  font-size: 14px;
  border: 0px !important;
  border-radius: 4px;
  color: #515a6e;
  background-color: #fff;
  background-image: none;
  position: relative;
  cursor: text;
  transition: border 0.2s ease-in-out, background 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out;
}
.ivu-form .ivu-form-item-label {
  text-align: left !important;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #515a6e;
  line-height: 1;
  padding: 10px 12px 10px;
  box-sizing: border-box;
}
.ivu-form .ivu-form-item-label {
  text-align: left !important;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #515a6e;
  line-height: 1;
  padding: 10px 12px 10px;
  box-sizing: border-box;
}
.myHead {
  position: absolute;
  top: 0px;
  left: 250px;
  width: 80%;
  height: 160px;
}
</style>
